import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useProContext } from '../context/ProContext';
import ProLayout from '../layout/ProLayout';
import SettingsModal from '../modals/SettingsModal';

const SettingsPage = () => {
  const { currentUser, updateUser } = useProContext();
  const navigate = useNavigate();

  return (
    <ProLayout title="Reglages">
      <div className="modal-as-page h-full">
        <SettingsModal
          isOpen={true}
          onClose={() => navigate('/optician-dashboard')}
          currentUser={currentUser}
          onUpdateUser={updateUser}
        />
      </div>
    </ProLayout>
  );
};

export default SettingsPage;
